module.exports = __webpack_public_path__ + "static/media/sciana.df06d576.jpg";